import { useEffect, useState } from 'react';
import { confirm } from '../utils/confirm';
import { useToast } from '../components/Toast';
import { fmtDateTime } from '../utils/format';
import { listNotes, createNote, updateNote, removeNote } from '../api/notes';

export default function NotesPage() {
  const toast = useToast();
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [draft, setDraft] = useState('');
  const [composing, setComposing] = useState(false); // hiện ô soạn ghi chú mới
  const [editing, setEditing] = useState(null); // id đang sửa
  const [editText, setEditText] = useState('');

  function reload() {
    setLoading(true);
    listNotes({ search: search || undefined })
      .then(setNotes)
      .finally(() => setLoading(false));
  }
  useEffect(reload, [search]);

  async function add() {
    if (!draft.trim()) return;
    try {
      await createNote({ content: draft.trim() });
      setDraft('');
      setComposing(false);
      reload();
    } catch (err) {
      toast(err.response?.data?.message || 'Có lỗi', 'danger');
    }
  }
  async function saveEdit(id) {
    try {
      await updateNote(id, { content: editText });
      setEditing(null);
      reload();
    } catch (err) {
      toast(err.response?.data?.message || 'Có lỗi', 'danger');
    }
  }
  async function togglePin(n) {
    await updateNote(n._id, { pinned: !n.pinned });
    reload();
  }
  async function del(id) {
    if (!await confirm('Xóa ghi chú này?')) return;
    await removeNote(id);
    reload();
  }

  return (
    <>
      <div className="page-head">
        <div>
          <h2>Ghi chú</h2>
          <div className="sub">Ghi chú cá nhân của bạn — chỉ mình bạn xem được</div>
        </div>
        <div className="row" style={{ gap: 8 }}>
          <input
            style={{ maxWidth: 240 }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="🔍 Tìm trong ghi chú…"
          />
          <button className="btn" onClick={() => setComposing((v) => !v)}>
            ＋ Ghi chú mới
          </button>
        </div>
      </div>

      {composing && (
        <div className="card" style={{ marginBottom: 16 }}>
          <textarea
            rows={3}
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            placeholder="Viết ghi chú mới…"
            autoFocus
            style={{ marginBottom: 8 }}
          />
          <div className="row" style={{ justifyContent: 'flex-end', gap: 8 }}>
            <button className="btn ghost" onClick={() => { setComposing(false); setDraft(''); }}>
              Hủy
            </button>
            <button className="btn" disabled={!draft.trim()} onClick={add}>
              Lưu ghi chú
            </button>
          </div>
        </div>
      )}

      {loading ? (
        <div className="card">
          <div className="empty">Đang tải…</div>
        </div>
      ) : !notes.length ? (
        <div className="card">
          <div className="empty">Chưa có ghi chú nào.</div>
        </div>
      ) : (
        <div className="notes-grid">
          {notes.map((n) => (
            <div key={n._id} className={'card note-card' + (n.pinned ? ' pinned' : '')}>
              <div className="row between" style={{ marginBottom: 6 }}>
                <span className="small muted">
                  {n.source === 'chat' ? `💬 Từ chat${n.fromName ? ` · ${n.fromName}` : ''}` : '📝 Ghi chú'}
                </span>
                <div className="row" style={{ gap: 4 }}>
                  <button className="btn sm ghost" title="Ghim" onClick={() => togglePin(n)}>
                    {n.pinned ? '📌' : '📍'}
                  </button>
                  <button className="btn sm ghost" onClick={() => { setEditing(n._id); setEditText(n.content); }}>
                    Sửa
                  </button>
                  <button className="btn sm ghost" onClick={() => del(n._id)}>
                    Xóa
                  </button>
                </div>
              </div>
              {editing === n._id ? (
                <>
                  <textarea rows={4} value={editText} onChange={(e) => setEditText(e.target.value)} />
                  <div className="row" style={{ marginTop: 6 }}>
                    <div className="spacer" />
                    <button className="btn sm ghost" onClick={() => setEditing(null)}>
                      Hủy
                    </button>
                    <button className="btn sm" onClick={() => saveEdit(n._id)}>
                      Lưu
                    </button>
                  </div>
                </>
              ) : (
                <div
                  className="note-content"
                  style={{ cursor: 'pointer' }}
                  title="Bấm để sửa ghi chú"
                  onClick={() => { setEditing(n._id); setEditText(n.content); }}
                >
                  {n.content || <span className="muted">(trống) — bấm để sửa</span>}
                </div>
              )}
              <div className="small muted" style={{ marginTop: 8 }}>
                {fmtDateTime(n.updatedAt)}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
